export const parseCapacity = (capacity) => {
  if (!capacity || typeof capacity !== 'object' || Array.isArray(capacity)) return null;

  const value = typeof capacity.value === 'number' || typeof capacity.value === 'string'
    ? Number(capacity.value)
    : NaN;
  const unit = typeof capacity.unit === 'string' ? capacity.unit.trim() : '';

  return Number.isFinite(value) && value > 0 && unit ? { value, unit } : null;
};

export const formatCapacity = (capacity, locale) => {
  const parsedCapacity = parseCapacity(capacity);
  if (!parsedCapacity) return null;

  try {
    return `${new Intl.NumberFormat(locale).format(parsedCapacity.value)} ${parsedCapacity.unit}`;
  } catch {
    return null;
  }
};
